import * as React from 'react'

// libs
import { createUseStyles } from "react-jss";


const useStyles = createUseStyles({
  containerRoot: {
    position: 'fixed',
    top: 'var(--appbar-height)',
    right: 0,
    left: 0,
    bottom: 0,
    padding: '1rem',
    paddingTop: 0,
    pointerEvents: 'none',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    '& > div': {
      // flex: 1,
      '& > *': {
        pointerEvents: 'all'
      }
    }
  }
})

interface Props {
  children: React.ReactElement
}

export default function Container({ children }: Props) {

  // styles
  const styles = useStyles();

  return (
    <div className={styles.containerRoot}>
      <div>
        {children}
      </div>
    </div>
  )
}